// extracted by mini-css-extract-plugin
export default {"expressCheckoutSection":"ME-z","expressButtonContainerWithPayPal":"NE-z","expressButton":"OE-z","or":"PE-z"};